<!-- 图片收集题：侧栏设置组件  -->
<template>
  <div class="image-card-setting">
    <vh-switch
      class="swtich"
      size="mini"
      v-model="isMust"
      active-color="#FB3A32"
      inactive-color="#CECECE"
      inactive-text="必填项"
    ></vh-switch>
    <div class="tip-container">
      <p class="tip-row title">提示：</p>
      <p class="tip-row">1. 图片收集题只能添加1个</p>
      <p class="tip-row">2. 支持观众最多上传3张图片</p>
    </div>
  </div>
</template>
<script>
  export default {
    props: {
      value: Boolean
    },
    computed: {
      isMust: {
        get() {
          return this.value;
        },
        set(val) {
          this.$emit('input', val);
        }
      }
    }
  };
</script>
<style lang="less" scoped>
  .image-card-setting {
    .tip-container {
      font-size: 14px;
      color: #8c8c8c;

      .tip-row {
        line-height: 1.6;
      }
      .tip-row.title {
        line-height: 2;
      }
    }
  }
</style>
